import { render } from "./PartnerPortalUserListTable.vue?vue&type=template&id=77adf9d7&ts=true"
import script from "./PartnerPortalUserListTable.vue?vue&type=script&lang=ts"
export * from "./PartnerPortalUserListTable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__